import React, { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'
import { useBreakpoint } from '../hooks/use-breakpoint'
import { DesktopHeadBanner } from './desktop-head-banner'
import { MobileHeadBanner } from './mobile-head-banner'

const Outer = styled.div``

type HeadBannarProps = {
  desktop: () => ReactNode,
  mobile: () => ReactNode
}
export const HeadBannar: FunctionComponent<HeadBannarProps> = ({desktop, mobile}) => {
  const isMobile = useBreakpoint('40rem')
  return <Outer>
    {
      isMobile ?
      <MobileHeadBanner>
        {mobile()}
      </MobileHeadBanner> :
      <DesktopHeadBanner>
        {desktop()}
      </DesktopHeadBanner>
    }
  </Outer>
}